import React from 'react';
import { Icon } from './Icon.js';
export const IconBookmarkCheck = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M4 2H20V21.5L12 17.5L4 21.5V2Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8.5 10.5L10.5 12.5L15.5 7.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconBookmarkCheck.js.map